//prefixing all styles with lbs-result-list-wrapper so they don't bleed out
export const BsrTemplateStyles = (isMobile) => `
.lbs-result-list-wrapper .result-root {
  ${isMobile ? "display: block" : "display: flex"}; 
  height: 100%;
}

.lbs-result-list-wrapper .result-root>div {
  display: flex;
  flex-direction: column;
}

.lbs-result-list-wrapper .result-root > article {
  display: flex;
  flex-direction: column;
}

.lbs-result-list-wrapper .result-root > article > div {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.lbs-result-list-wrapper .tag a {
  padding: 5px 6px 2px;
  color: #001e62;
  border: 1px solid #d7d2cb;
  display: inline-block;
  font-size: 0.625rem;
  text-decoration: none;
  margin: 0 10px 10px 0;
  font-weight: 700;
  font-family: var(--lbs-base-font-family), sans-serif;
}

.lbs-result-list-wrapper .social-share {
  align-self: flex-end;
  margin-left: auto;
}

.lbs-result-list-wrapper .tag a:hover, .lbs-result-list-wrapper .tag a:focus {
  background: #001e62;
  border: 1px solid #001e62;
  color: #fff;
}

.lbs-result-list-wrapper .text1 {
  padding: 26px 26px 30px;
  background-color: #fff;
  color: #001e62;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  -ms-flex-positive: 2;
  flex-grow: 2;
}

.lbs-result-list-wrapper .primary-tag {
  line-height: 1.57143;
  letter-spacing: 0.88px;
  font-size: 0.875rem;
  font-weight: 400;
  font-family: var(--lbs-base-font-family), sans-serif;
  color: #6e6259;
  text-transform: uppercase;
  margin-bottom: 5px;
}

.lbs-result-list-wrapper h2.h3 {
  line-height: 1.26667;
  font-size: 1.875rem;
  margin-bottom: 40px;
}

.lbs-result-list-wrapper .sub-heading {
  color: #001e62;
  line-height: 1.5;
  font-size: 1rem;
  margin-bottom: 10px;
  font-family: var(--lbs-base-font-family), sans-serif;
}

.lbs-result-list-wrapper .copy {
  line-height: 1.5;
  color: #001440;
  margin-bottom: 15px;
  font-weight: 400;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  font-size: 1rem;
  font-family: var(--lbs-base-font-family), sans-serif;
}

.lbs-result-list-wrapper .article-panel .text .info-field {
  line-height: 1.71429;
  color: #6e6259;
  font-size: 0.875rem;
}

.lbs-result-list-wrapper .info-field {
  line-height: 1.71429;
  color: #6e6259;
  font-family: var(--lbs-base-font-family), sans-serif;
  font-size: 0.875rem;
  font-weight: 500;
}

.lbs-result-list-wrapper .authors {
  margin-left: 4px;
}

.lbs-result-list-wrapper .footer {
  height: 150px;
  border-top: 1px solid #d8d8d8;
  display: flex;
  flex-wrap: wrap;
  padding-top: 30px;
  margin-top: auto;
}

.lbs-result-list-wrapper svg {
  height: 40px;
}

.lbs-result-list-wrapper footer {
  border-top: 1px solid #d8d8d8;
  display: flex;
  flex-wrap: wrap;
  padding-top: 30px;
  margin-top: auto;
}

.lbs-result-list-wrapper .card-footer {
  display: flex;
  flex-wrap: wrap;
  border-top: 1px solid #d8d8d8;
  padding-top: 30px;
  margin-top: auto;
}

.lbs-result-list-wrapper .social-share {
  align-self: flex-end;
  margin-left: auto;
}

.lbs-result-list-wrapper .social-share a {
  transition: transform .3s;
}

.lbs-result-list-wrapper .social-share a:hover {
  transform: scale(1.1);
}

.lbs-result-list-wrapper .imageLink {
  display: flex;
}

.lbs-result-list-wrapper .imageLink img {
  height: auto;
}

.lbs-result-list-wrapper .wrapperImage {
  display: block;
  min-height: 1px;
  overflow: hidden;
  position: relative;
}



.lbs-result-list-wrapper .social-share {
  display: inline-block;
  height: 30px;
  position: relative;
  width: 30px;
}

.lbs-result-list-wrapper .social-share .visually-hidden {
  position: absolute;
  left: -10000px;
  top: auto;
  width: 1px;
  height: 1px;
  overflow: hidden;
}

.lbs-result-list-wrapper .social-share i svg {
  fill: #001e62;
  ;
  height: 100%;
  transition: all 0.2s linear;
  width: 100%;
}

@media (hover: hover) {
  .lbs-result-list-wrapper .social-share a:hover i svg {
    fill: #5f739b;
  }
}

.social-share .share-links {
  align-items: center;
  background: #fff;
  bottom: calc(100% + 15px);
  box-shadow: 0 0 10px 3px rgba(0, 0, 0, 0.15);
  display: none;
  justify-content: space-between;
  padding: 10px;
  position: absolute;
  right: -4px;
  width: 130px;
  z-index: 2;
}

.lbs-result-list-wrapper .social-share .share-links::before {
  background: #fff;
  box-shadow: 0 0 10px 3px rgba(0, 0, 0, 0.15);
  bottom: -7px;
  display: block;
  content: " ";
  height: 18px;
  position: absolute;
  pointer-events: none;
  right: 10px;
  transform: rotate(45deg);
  width: 18px;
}

.lbs-result-list-wrapper .social-share .share-links::after {
  background: #fff;
  bottom: 0;
  content: " ";
  display: block;
  height: 25px;
  pointer-events: none;
  position: absolute;
  right: 0;
  width: 40px;
}

.lbs-result-list-wrapper .social-share .share-links li {
  display: inline-block;
  margin-bottom: 0;
  position: relative;
  height: 30px;
  width: 30px;
  z-index: 3;
}

.lbs-result-list-wrapper .social-share .share-links li a {
  display: block;
  height: 30px;
  width: 30px;
}

.lbs-result-list-wrapper .social-share .share-links li i {
  display: block;
  height: 30px;
  left: 0;
  position: absolute;
  top: 0;
  width: 30px;
}

.lbs-result-list-wrapper .social-share .share-links li i.icon-facebook {
  height: 35px;
  left: -2px;
  width: 35px;
  top: -3px;
}

.lbs-result-list-wrapper .social-share.show .share-toggle svg {
  fill: #5f739b;
  transform: rotate(90deg);
}

.lbs-result-list-wrapper .social-share.show .share-links {
  display: flex;
}

`;
